module.exports = __webpack_public_path__ + "static/media/competecny-assessment-delete-icon.c57d24ff.svg";